<template>
  <div class="list-menu-v1-mini__container">
    <div
      :class="
        item.active
          ? darkTheme
            ? 'active '
            : 'active list-menu-v1-mini-content'
          : darkTheme
          ? ' list-menu-v1-mini-content-dark'
          : ' list-menu-v1-mini-content'
      "
      :name="item.name"
      :color="item.active ? item.color : ''"
      v-for="(item, index) in itemDefault"
      v-show="!item.hidden"
      @click="changeNavicationRouteItem($event, item)"
      :key="index"
      :title="$t(item.title)"
      :style="{}"
    >
      <v-tooltip
        right
        class="item-menu-v1-mini"
        :class="
          item.active
            ? `${darkTheme ? ' active' : 'item-menu-v1 active'} `
            : `${darkTheme ? 'item-menu-v1-dark' : 'item-menu-v1'} `
        "
      >
        <template v-slot:activator="{ on }">
          <v-list-tile-action>
            <v-icon
              v-on="on"
              :class="item.active ? 'item-menu__mini-active' : 'item-menu__mini'"
              :color="item.active ? item.color : ''"
              >{{ item.icon }}</v-icon
            >
          </v-list-tile-action>
        </template>
        <span>{{ item.name }}</span>
      </v-tooltip>
    </div>
    <v-list-tile
      :class="darkTheme ? 'btn-login-dark' : 'btn-login'"
      :title="$t('page.sign_in')"
      @click="changeNavicationRouteItem($event, { route: '/sign-in', name: 'sign-in' })"
      :style="{
        display: 'flex',
        justifyContent: mini ? 'center' : 'stretch',
        width: '100%'
      }"
    >
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-list-tile-action v-on="on" v-if="mini">
            <v-icon>arrow_forward</v-icon>
          </v-list-tile-action>
        </template>
        <span>Đăng nhập</span>
      </v-tooltip>
    </v-list-tile>
  </div>
</template>
<script>
export default {
  name: 'ListMenuItemMiniWithoutProfile',
  props: {
    mini: {
      type: Boolean
    },
    onChangeRoute: {
      type: Function
    }
  },
  data() {
    return {
      itemDefault: [
        {
          icon: 'bookmark',
          title: 'page.booking',
          route: '/records',
          color: '#0050B3',
          name: 'records'
        },
        {
          icon: 'dashboard',
          title: 'page.dashboards',
          route: '/dashboards',
          color: '#0050B3',
          name: 'dashboards'
        },

        {
          icon: 'event_available',
          title: 'page.verify_order',
          route: '/verify-order',
          color: '#0050B3',
          name: 'verify_order',
          hidden:
            !this.$store.getters.userProfile ||
            !this.$store.getters.userProfile.partner ||
            this.$constants.NEED_CONFIRM_PICKUP_PARTNERS.indexOf(
              this.$store.getters.userProfile.partner
            ) == -1
        },
        {
          icon: 'people',
          title: 'page.employees',
          route: '/employees',
          color: 'accent',
          name: 'employees'
        }
      ]
    }
  },
  methods: {
    onChangeNavicationMini() {
      this.$emit('changeNavicationMini')
    },
    changeNavicationRouteItem($event, item) {
      this.$emit('onChangeRoute', $event, item)
    }
  },
  computed: {
    darkTheme() {
      const theme = this.$store.getters.theme
      if (!theme) return false
      return theme
    }
  }
}
</script>
<style scoped lang="scss">
.list-menu-v1-mini__container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 0 16px 48px 16px;

  .btn-login-dark {
    &:hover {
      background-color: rgba(230, 233, 236, 0.11);
      border-radius: 6px;
      cursor: pointer;
    }
  }

  .btn-login {
    &:hover {
      background-color: #e6e9ec;
      border-radius: 6px;
      cursor: pointer;
    }
  }

  &::-webkit-scrollbar {
    width: 0;
  }

  .active {
    border-radius: 6px;
    background-color: #e6e9ec;
    color: #0050b3;
  }

  .list-menu-v1-mini-content {
    padding: 12px 0;

    .v-list__tile__action {
      min-width: auto !important;
    }

    &:hover {
      border-radius: 6px;
      background-color: #e6e9ec;
      cursor: pointer;
    }
  }

  .list-menu-v1-mini-content-dark {
    padding: 12px 0;

    .v-list__tile__action {
      min-width: auto !important;
    }

    &:hover {
      border-radius: 6px;
      background: rgba(255, 255, 255, 0.15);
      cursor: pointer;
    }
  }
}

.v-list__tile__action {
  min-width: auto;
}

.v-tooltip__content {
  margin-left: 8px !important;
}
</style>
